<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AB49w7/tc-custom/9780226563602.jpg?1733115328841" alt="This image is the cover for the book Singing in the Age of Anxiety"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Singing in the Age of Anxiety
      </h1>
      <p class="bookDescription body article font2">
        <p>In New York and London during World War I, the performance of lieder—German art songs—was roundly prohibited, representing as they did the music and language of the enemy. But as German musicians returned to the transatlantic circuit in the 1920s, so too did the songs of Franz Schubert, Hugo Wolf, and Richard Strauss. Lieder were encountered in a variety of venues and media—at luxury hotels and on ocean liners, in vaudeville productions and at Carnegie Hall, and on gramophone recordings, radio broadcasts, and films. <br/><br/> Laura Tunbridge explores the renewed vitality of this refugee musical form between the world wars, offering a fresh perspective on a period that was pervaded by anxieties of displacement. Through richly varied case studies, <i>Singing in the Age of Anxiety</i> traces how lieder were circulated, presented, and consumed in metropolitan contexts, shedding new light on how music facilitated unlikely crossings of nationalist and internationalist ideologies during the interwar period.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laura Tunbridge
      </h2>
      
      <p class="authorDescription body article"><B>Laura Tunbridge</B> is Professor of Music and Henfrey Fellow and Tutor in Music at St Catherine’s College, University of Oxford. She is the author of <I>Schumann’s Late Style</I> and <I>The Song Cycle.</I><br> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b02b7a2